module.exports = __webpack_public_path__ + "static/specificity-05059405ad436bc7e0f04173f8529ecb.png";